import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { ClientAccount, Glossary } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import clientUtil from 'utils/clientUtil';

type TData = Glossary[];

export const useGlossariesOptions = (
  options: Omit<UseQueryOptions<unknown, TGenericError, TData>, 'queryKey'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    query glossariesOptions {
      clientAccount {
        glossaries {
          nodes {
            id
            name
          }
        }
      }
    }
  `;

  return useQuery<unknown, TGenericError, TData>({
    ...options,
    queryKey: ['useGlossariesOptions'],
    queryFn: async () => {
      const response: ClientAccount = await client.request({
        data: {
          gql: graphql
        }
      });

      return response?.glossaries?.nodes ?? [];
    }
  });
};
